/**
 * Fetch root comments (parentId is null) for a given mediaPath.
 * Mirrors Flutter ContentReactionsRepository.getComments(mediaPath, null, ...).
 */

import { CommentService } from '@/domain/services/comment/commentService';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';
import type { PageCursor } from '@/data/types/json';
import type { CommentEntity } from '@/domain/entities/comment/commentEntity';

export interface FetchRootCommentsResult {
  comments: CommentEntity[];
  hasMore: boolean;
  cursor?: PageCursor;
}

export class FetchRootCommentsUseCase {
  constructor(private service = CommentService.getInstance()) {}

  async execute(
    mediaPath: string,
    cursor?: PageCursor,
    limit: number = SERVER_FETCH_CONSTANTS.MESSAGES_LIST_PAGINATION,
  ): Promise<FetchRootCommentsResult> {
    return this.service.fetchComments(mediaPath, null, limit, cursor);
  }
}

export const fetchRootCommentsUseCase = new FetchRootCommentsUseCase();
